module.exports = __webpack_public_path__ + "img/1556095791.6cbf7869.jpg";